import { useState } from "react";
import type { Area } from "react-easy-crop";
import type { IImageCropperContext } from "./ImageCropper";
import { getCroppedImg } from "./get-cropped-image";

interface IImageCropperContainerProps {
  image: string;
  children: (props: {
    context: IImageCropperContext;
    validateCrop: () => Promise<Blob>;
  }) => React.ReactNode;
}

export function ImageCropperContainer({
  image,
  children,
}: IImageCropperContainerProps) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);

  const resetCrop = () => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  };

  const validateCrop = async () => {
    const cropped = await getCroppedImg(image, croppedAreaPixels);
    resetCrop();
    return cropped;
  };

  const context = {
    image,
    zoom,
    crop,
    setZoom,
    setCrop,
    setCroppedAreaPixels,
  };

  return children({ context, validateCrop });
}
